import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Reader from "../pages/reader/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/reader",
    element: <Reader />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;